<template>
  <img :src="avatar" :alt="alt" class="story-avatar" />
</template>

<script>
export default {
  props: {
    avatar: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.story-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}
</style>
